<template>
  <ag-card-container
    :search.sync="search"
    :title="$t('player.title.playerList')"
    fluid
  >
    <template #left>
      <v-btn
        color="accent"
        small
        block
        @click="exportPlayers"
      >
        <v-icon left>
          mdi-file-excel
        </v-icon>
        {{ $t('general.export') }}
      </v-btn>
    </template>
    <player-list
      :value="playerList"
      :loading="loadingData"
      :search="search"
    />

    <!-- RouterView for modals -->
    <router-view />
  </ag-card-container>
</template>

<script>
import AgCardContainer from 'src/components/common/AgCardContainer'
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'
import { downloadExcelFile } from 'src/services/exportExcelService'
import { getLanguageText } from 'src/plugins/i18n'
import { format, parseISO } from 'date-fns'
import Helpers from 'src/utils/helpers'
import _omit from 'lodash/omit'
import PlayerList from '../components/PlayerList'

export default {
  name: 'PlayerListContainer',
  components: {
    AgCardContainer,
    PlayerList,
  },
  data: () => ({
    rawPlayerList: [],
    search: '',
    loadingData: false,
  }),
  computed: {
    playerList () {
      const items = this.rawPlayerList.map(player => ({
        id: player.id,
        sessionName: player.trainingSession.name,
        dateCreate: format(parseISO(player.trainingSession.dateCreate), this.$t('date.dateAndTime')),
        lang: getLanguageText(player.trainingSession.lang),
        playerName: player.name,
        playerEmail: player.email,
      }))

      return this.search !== ''
        ? items.filter(player => Object.values(_omit(player, 'id'))
          .some(text => Helpers.localeIncludes(text, this.search)))
        : items
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'PlayerList') {
          this.fetchData()
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    async fetchData () {
      this.loadingData = true
      this.rawPlayerList = await Repositories.trainingSession.player.getList()
      this.loadingData = false
    },
    exportPlayers () {
      downloadExcelFile({
        sheetList: [
          {
            headers: [
              {
                header: this.$t('player.fields.session.name'),
                key: 'sessionName',
                width: 30,
              },
              {
                header: this.$t('player.fields.session.dateCreate'),
                key: 'dateCreate',
                width: 20,
              },
              {
                header: this.$t('general.language'),
                key: 'lang',
                width: 15,
              },
              {
                header: this.$t('player.fields.player.name'),
                key: 'playerName',
                width: 25,
              },
              {
                header: this.$t('player.fields.player.email'),
                key: 'playerEmail',
                width: 40,
              },
            ],
            rows: this.playerList,
            sheetname: this.$t('player.export.sheetname'),
          },
        ],
        filename: this.$t('player.export.filename'),
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.float-chip {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 12px;
}
</style>
